import script from "./product4View.vue?vue&type=script&setup=true&lang=js"
export * from "./product4View.vue?vue&type=script&setup=true&lang=js"

import "./product4View.vue?vue&type=style&index=0&id=73e445d8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73e445d8"]])

export default __exports__